import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { AboutPage } from './pages/AboutPage';
import { FinancingPage } from './pages/FinancingPage';
import { TestimonialsPage } from './pages/TestimonialsPage';
import { BlogPage } from './pages/BlogPage';
import { TreatmentsPage } from './pages/TreatmentsPage';
import { WrinkleRelaxersPage } from './pages/WrinkleRelaxersPage';
import { DermalFillersPage } from './pages/DermalFillersPage';
import { PdoThreadsPage } from './pages/PdoThreadsPage';
import { SculptraPage } from './pages/SculptraPage';
import { FatDissolvingPage } from './pages/FatDissolvingPage';
import { LaserHairRemovalPage } from './pages/LaserHairRemovalPage';
import { SkinTytePage } from './pages/SkinTytePage';
import { BBLPage } from './pages/BBLPage';
import { ClearSilkPage } from './pages/ClearSilkPage';
import { ClearBrilliantPage } from './pages/ClearBrilliantPage';
import { SkinResurfacingPage } from './pages/SkinResurfacingPage';
import { VaginalRejuvenationPage } from './pages/VaginalRejuvenationPage';
import { CoolTonePage } from './pages/CoolTonePage';
import { CoolSculptingElitePage } from './pages/CoolSculptingElitePage';
import { WeightLossMenPage } from './pages/WeightLossMenPage';
import { WeightLossWomenPage } from './pages/WeightLossWomenPage';
import { PotenzaPage } from './pages/PotenzaPage';
import { MicroneedlingPage } from './pages/MicroneedlingPage';
import { ChemicalPeelsPage } from './pages/ChemicalPeelsPage';
import { HydropowerPage } from './pages/HydropowerPage';
import { KoreanMesotherapyPage } from './pages/KoreanMesotherapyPage';
import { DermaplaningWaxingPage } from './pages/DermaplaningWaxingPage';
import { IVInfusionsPage } from './pages/IVInfusionsPage';
import { BHRTPage } from './pages/BHRTPage';
import { TRTPage } from './pages/TRTPage';
import { OShotPage } from './pages/OShotPage';
import { PShotPage } from './pages/PShotPage';
import { HairRestorationPage } from './pages/HairRestorationPage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/about" element={<AboutPage data-id="element-5" />} data-id="element-4" />
        <Route path="/financing" element={<FinancingPage data-id="element-7" />} data-id="element-6" />
        <Route path="/testimonials" element={<TestimonialsPage data-id="element-9" />} data-id="element-8" />
        <Route path="/blog" element={<BlogPage data-id="element-11" />} data-id="element-10" />
        <Route path="/treatments" element={<TreatmentsPage data-id="element-13" />} data-id="element-12" />
        <Route path="/wrinkle-relaxers" element={<WrinkleRelaxersPage data-id="element-15" />} data-id="element-14" />
        <Route path="/dermal-fillers" element={<DermalFillersPage data-id="element-17" />} data-id="element-16" />
        <Route path="/pdo-threads" element={<PdoThreadsPage data-id="element-19" />} data-id="element-18" />
        <Route path="/sculptra" element={<SculptraPage data-id="element-21" />} data-id="element-20" />
        <Route path="/fat-dissolving-injections" element={<FatDissolvingPage data-id="element-23" />} data-id="element-22" />
        <Route path="/laser-hair-removal" element={<LaserHairRemovalPage data-id="element-25" />} data-id="element-24" />
        <Route path="/skintyte-laser" element={<SkinTytePage data-id="element-27" />} data-id="element-26" />
        <Route path="/bbl" element={<BBLPage data-id="element-29" />} data-id="element-28" />
        <Route path="/clearsilk" element={<ClearSilkPage data-id="element-31" />} data-id="element-30" />
        <Route path="/clear-brilliant" element={<ClearBrilliantPage data-id="element-33" />} data-id="element-32" />
        <Route path="/skin-resurfacing" element={<SkinResurfacingPage data-id="element-35" />} data-id="element-34" />
        <Route path="/vaginal-rejuvenation" element={<VaginalRejuvenationPage data-id="element-37" />} data-id="element-36" />
        <Route path="/cooltone" element={<CoolTonePage data-id="element-39" />} data-id="element-38" />
        <Route path="/coolsculpting-elite" element={<CoolSculptingElitePage data-id="element-41" />} data-id="element-40" />
        <Route path="/weight-loss-for-men" element={<WeightLossMenPage data-id="element-43" />} data-id="element-42" />
        <Route path="/weight-loss-for-women" element={<WeightLossWomenPage data-id="element-45" />} data-id="element-44" />
        <Route path="/potenza-radio-frequency-microneedling" element={<PotenzaPage data-id="element-47" />} data-id="element-46" />
        <Route path="/microneedling" element={<MicroneedlingPage data-id="element-49" />} data-id="element-48" />
        <Route path="/chemical-peels" element={<ChemicalPeelsPage data-id="element-51" />} data-id="element-50" />
        <Route path="/hydropower-facial" element={<HydropowerPage data-id="element-53" />} data-id="element-52" />
        <Route path="/korean-mesotherapy" element={<KoreanMesotherapyPage data-id="element-55" />} data-id="element-54" />
        <Route path="/dermaplaning-waxing" element={<DermaplaningWaxingPage data-id="element-57" />} data-id="element-56" />
        <Route path="/iv-infusions-injections" element={<IVInfusionsPage data-id="element-59" />} data-id="element-58" />
        <Route path="/bioidentical-hormone-replacement-therapy" element={<BHRTPage data-id="element-61" />} data-id="element-60" />
        <Route path="/testosterone-replacement-therapy-for-men" element={<TRTPage data-id="element-63" />} data-id="element-62" />
        <Route path="/o-shot-for-women" element={<OShotPage data-id="element-65" />} data-id="element-64" />
        <Route path="/performance-enhancement-shot" element={<PShotPage data-id="element-67" />} data-id="element-66" />
        <Route path="/hair-restoration-for-men" element={<HairRestorationPage data-id="element-69" />} data-id="element-68" />
      </Routes>
    </Router>;
}